import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardBuyCreditPacksRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardBuyCreditPacksContainerLoadable } from './OrgDashboardBuyCreditPacksContainerLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof orgDashboardBuyCreditPacksRoute>,
) {
  await OrgDashboardBuyCreditPacksContainerLoadable.load();
}

export default function OrgDashboardBuyCreditPacksHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Buy Credit Packs')}>
      <OrgDashboardBuyCreditPacksContainerLoadable />
    </RouteModule>
  );
}
